import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getWoningTextResources = createGetTextResources({
  TooltipEnergieLabel: `Voor een woning met energielabel E, F of G mag maximaal € 20.000 extra geleend worden. Bij een woning met energielabel C of D mag maximaal € 15.000 extra geleend worden. Bij alle andere energielabel of als er geen energielabel beschikbaar of mogelijk is, mag maximaal € 10.000 extra geleend worden.`,
  ErrorDatumTaxatieToekomst: "Vul een geldige datum in.",
  OnderPandSpecificatieKnop: "Onderpand knop",
  ErrorFotoGebruikRapportage: "Upload een foto of selecteer 'nee' bij 'Foto in rapportage opnemen'."
});
